import Cookies from "js-cookie";

export default class RudderstackTracking {
  constructor() {
    if (!window.rudderanalytics) {
      return;
    }

    const appStoreLinks = document.querySelectorAll(
      '[data-rudderstack="appstore"]'
    );
    const playStoreLinks = document.querySelectorAll(
      '[data-rudderstack="playstore"]'
    );

    const gaCookie = Cookies.get("_ga")?.substring(6);
    const gaClientId = gaCookie ? gaCookie : null;
    const urlUtmParams = Array.from(
      new URLSearchParams(window.location.search)
    ).reduce((params, [key, value]) => {
      if (key.startsWith("utm_")) {
        params[key] = value;
      }

      return params;
    }, {});

    const properties = {};

    if (gaClientId) {
      properties.ga_client_id = gaClientId;
    }

    if (Object.keys(urlUtmParams)?.length) {
      properties.utm_params = urlUtmParams;
    }

    // page view
    window.rudderanalytics.track("website_start", properties);

    // app store links
    appStoreLinks.forEach((link) => {
      link.addEventListener("click", () => {
        window.rudderanalytics.track("website_appstore_click", properties);
      });
    });

    // play store links
    playStoreLinks.forEach((link) => {
      link.addEventListener("click", () => {
        window.rudderanalytics.track("website_playstore_click", properties);
      });
    });
  }
}
